import workspaceQuery from 'graphql/queries/sales/ChannelConfigurationWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/sales/ChannelConfigurationQuery.graphql';
import defaultQuery from 'graphql/queries/sales/ChannelConfigurationDefault.graphql';
import listQuery from 'graphql/queries/sales/ChannelConfigurationListQuery.graphql';
import mutationQuery from 'graphql/mutations/sales/ChannelConfigurationMutation.graphql';
import fragment from 'graphql/fragments/sales/ChannelConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ChannelConfiguration = {
  type: 'GenericChannel',
  title: 'Other Channel Configurations',
  formTitle: 'Other Channel Configuration',
  formUrl: '/Sales/Channel/ChannelConfig/Details/',
  workspaceUrl: '/Sales/Channel/ChannelConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'identifier',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SALES_CHANNEL_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default ChannelConfiguration;
